<template>
  <div class="w-full px-3 py-2 flex" :class="classes">
    <div
      class="min-w-[40px] max-w-[40px] min-h-[40px] max-h-[40px] mr-3 p-0.5 rounded-sm bg-gray-200/20 relative"
    >
      <ThumbnailIcon
        class="w-full h-full"
        :icon-size="36"
        :image-url="notification.primaryIcon.imageUrl"
        :type="(notification.metadata as FileMetadata).file.type"
      />
      <div class="w-[18px] h-[18px] absolute -right-1 -bottom-1">
        <Icon
          v-if="props.notification.secondaryIcon?.alertIcon"
          :name="icon"
          class="mr-3 stroke-red-700"
        />
      </div>
    </div>
    <div
      class="font-secondary text-[14px] leading-5 tablet-h:leading-[19px] tablet-h:text-[13px] text-gray-800 -mt-1 flex flex-col justify-between"
    >
      <component :is="copy" class="mb-1 tablet-h:mb-0.5" />
      <div class="text-[13px] tablet-h:text-[12px] opacity-50">
        {{ formatDistanceToNowStrict(props.notification.timestamp) }} ago
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import {
  NotificationType,
  type FileMetadata,
  type UploadFileMetadata,
  type Notification,
} from '@/shared/graphql/legacy/generated'
import { formatDistanceToNowStrict } from 'date-fns'
import { computed, h } from 'vue'
import { ThumbnailIcon, Icon } from '@dacr/ui'

const props = defineProps<{
  notification: Notification
}>()

const classes = computed(() => ({
  'tablet-h:hover:bg-[#FAFAFA]': props.notification.read,
  'bg-green-900/10': !props.notification.read,
}))

const icon = computed(() => {
  if (props.notification.type === NotificationType.FileUploadFailed) {
    return 'CircleAlert'
  }

  return 'Alert'
})

const copy = computed(() => {
  if (props.notification.type === NotificationType.FileUploadFailed) {
    return h('div', [
      `Your file ${
        (props.notification.metadata as FileMetadata).file.vanityName
      } failed to process for Dacr copyright protection. Retry and if the issue continues please contact `,
      h(
        'a',
        {
          href: 'mailto:support@dacr.com',
          class: 'text-green-900',
        },
        'Dacr support.'
      ),
    ])
  }

  if (props.notification.type === NotificationType.FileUploadEmptyFile) {
    return h(
      'div',
      `Your file ${
        (props.notification.metadata as UploadFileMetadata).filename
      } failed to process. Please confirm the file is correct and try again.`
    )
  }

  return null
})
</script>
